import React from 'react';
import { Step } from './Step';
import text from '../../../../text';
import routes from '../../../../routes/constants';
import MembershipForm from './MembershipForm';
import StepFooter, { StepFooterButtonProps } from '../StepFooter';
import useRedirectToMap from '../../../hooks/useRedirectToMap';

const MembershipStep = ({
  membershipPriceId,
  onMembershipChange,
  includeNoMembership,
  nextButtonProps,
  previousButtonProps,
}: {
  membershipPriceId: string;
  onMembershipChange: (membershipPriceId: string) => void;
  includeNoMembership?: boolean;
  nextButtonProps: StepFooterButtonProps;
  previousButtonProps: StepFooterButtonProps;
}) => {
  const { redirectToMap } = useRedirectToMap();

  return (
    <>
      <Step
        className='MembershipStep'
        title={text('selectMembership')}
        extraText={
          <div>
            {text('membershipFeaturesSummary')}
            <div className='mt-3'>
              <a
                target='_blank'
                rel='noreferrer'
                href={routes.larkiWebsiteUrl.memberships}
              >
                {text('learnMore')}
              </a>
            </div>
          </div>
        }
      >
        <Step.Content>
          <MembershipForm
            includeNoMembership={includeNoMembership}
            membershipPriceId={membershipPriceId}
            onMembershipChange={onMembershipChange}
          />
        </Step.Content>
      </Step>
      <StepFooter
        previousButtonProps={previousButtonProps}
        nextButtonProps={nextButtonProps}
        onCancel={redirectToMap}
      />
    </>
  );
};

export default MembershipStep;
